import React from "react";
import { FormGroup, FormFeedback } from "reactstrap";
import MultiSelectDropdown from "shared/react_components/MultiSelectDropdown";
import { Field, getIn } from "formik";

const EmailNotificationsDropdown = () => {
  return (
    <Field name="user.emails">
      {({ field: { name, value = [] }, form }) => (
        <FormGroup>
          <MultiSelectDropdown
            options={value}
            selectedOptions={value.filter(({ notify }) => notify)}
            onSelectionChanged={selectedOptions => {
              const selected = selectedOptions.map(({ value }) => value);
              form.setFieldValue(
                name,
                value.map(email => ({
                  ...email,
                  notify: selected.includes(email.value)
                }))
              );
            }}
            showInvertBar={false}
          />
          {!Array.isArray(getIn(form.errors, "user.emails")) && (
            <FormFeedback className="d-block">
              {getIn(form.errors, "user.emails")}
            </FormFeedback>
          )}
        </FormGroup>
      )}
    </Field>
  );
};

EmailNotificationsDropdown.propsTypes = {};

export default EmailNotificationsDropdown;
